import type { ReduxApplicationState } from '../combinedReducer';

export const selectBasket = (state: ReduxApplicationState) => state.basket;
